(() => {
  const initVehicleMake = (root) => {
    if (!root || root.dataset.vmakeReady === 'true') return;
    root.dataset.vmakeReady = 'true';

    const search = root.querySelector('[data-vmake-search]');
    const suggestions = root.querySelector('[data-vmake-suggestions]');
    const empty = root.querySelector('[data-vmake-empty]');
    const start = root.querySelector('[data-vmake-start]');
    const results = root.querySelector('[data-vmake-results]');
    const compareBar = root.querySelector('[data-compare-bar]');
    const compareCount = root.querySelector('[data-compare-count]');
    const compareOpen = root.querySelector('[data-compare-open]');
    const compareModal = root.querySelector('[data-compare-modal]');
    const compareGrid = root.querySelector('[data-compare-grid]');
    const catalogMode = root.dataset.catalogMode || 'car';
    const selected = new Map();
    const normalize = (value = '') => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
    const escapeHtml = (value = '') => String(value).replace(/[&<>"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'
    })[character]);

    const scrollToElement = (element) => {
      if (!element) return;
      const header = document.querySelector('sticky-header, .shopify-section-header-sticky, [data-sticky-header]');
      const offset = header ? header.getBoundingClientRect().height + 18 : 18;
      window.scrollTo({ top: window.scrollY + element.getBoundingClientRect().top - offset, behavior: 'smooth' });
    };

    const suggestionButtons = () => [...root.querySelectorAll('[data-vmake-suggestions] [data-make-select]')];
    if (suggestions) {
      suggestionButtons()
        .sort((a, b) => (a.dataset.makeName || '').localeCompare(b.dataset.makeName || ''))
        .forEach((button) => suggestions.insertBefore(button, empty));
    }
    const popularOrder = (root.dataset.popularOrder || '').split('|').map(normalize);
    root.querySelectorAll('.vmake__chips, .vmake__popular-grid').forEach((container) => {
      [...container.querySelectorAll('[data-make-name]')]
        .sort((a, b) => popularOrder.indexOf(normalize(a.dataset.makeName)) - popularOrder.indexOf(normalize(b.dataset.makeName)))
        .forEach((button) => container.appendChild(button));
    });

    const filterSuggestions = () => {
      if (!suggestions || !search) return;
      const query = normalize(search.value);
      let visible = 0;
      suggestionButtons().forEach((button) => {
        const matches = !query || normalize(button.dataset.searchValue || button.dataset.makeName).includes(query);
        button.hidden = !matches;
        if (matches) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
      suggestions.hidden = false;
    };

    const showMake = (id, makeName = '', shouldScroll = true) => {
      const panel = root.querySelector(`[data-make-panel="${CSS.escape(id)}"]`);
      if (!panel || !results || !start) return;
      const selectedName = makeName || panel.dataset.defaultMake || (catalogMode === 'motorcycle' ? 'Motorcycle' : 'Vehicle');
      root.classList.add('vmake--has-selection');
      root.querySelectorAll('[data-make-panel]').forEach((item) => { item.hidden = item !== panel; });
      start.hidden = true;
      results.hidden = false;
      panel.hidden = false;
      suggestions && (suggestions.hidden = true);
      panel.querySelectorAll('[data-selected-make]').forEach((node) => { node.textContent = selectedName; });
      panel.querySelectorAll('[data-selected-heading]').forEach((node) => { node.textContent = `Recommended scanners for ${selectedName}`; });
      panel.querySelectorAll('[data-selected-rank]').forEach((node) => { node.textContent = `for ${selectedName}`; });
      if (search) search.value = selectedName;
      const url = new URL(window.location.href);
      url.searchParams.set('brand', selectedName);
      history.replaceState({}, '', url);
      if (shouldScroll) scrollToElement(results);
    };

    const showStart = () => {
      if (!results || !start) return;
      root.classList.remove('vmake--has-selection');
      results.hidden = true;
      start.hidden = false;
      root.querySelectorAll('[data-make-panel]').forEach((panel) => { panel.hidden = true; });
      if (search) search.value = '';
      const url = new URL(window.location.href);
      url.searchParams.delete('brand');
      history.replaceState({}, '', url);
      scrollToElement(root.querySelector('.vmake__hero'));
    };

    const syncCompare = () => {
      if (!compareBar || !compareCount) return;
      compareCount.textContent = selected.size;
      compareBar.hidden = selected.size === 0;
      if (compareOpen) {
        compareOpen.disabled = selected.size < 2;
        compareOpen.setAttribute('aria-disabled', String(selected.size < 2));
      }
    };

    const setCompare = (card, checked) => {
      const dataNode = card && card.querySelector('[data-compare-data]');
      const checkbox = card && card.querySelector('[data-compare-toggle]');
      if (!dataNode || !checkbox) return;
      let data;
      try { data = JSON.parse(dataNode.textContent); } catch (_error) { return; }
      if (checked && selected.size >= 3 && !selected.has(String(data.id))) {
        checkbox.checked = false;
        return;
      }
      if (checked) selected.set(String(data.id), data);
      else selected.delete(String(data.id));
      syncCompare();
    };

    const clearCompare = () => {
      selected.clear();
      root.querySelectorAll('[data-compare-toggle]').forEach((input) => { input.checked = false; });
      syncCompare();
    };

    const openCompare = () => {
      if (!compareModal || !compareGrid || selected.size < 2) return;
      const items = [...selected.values()];
      const header = items.map((item) => `
        <th scope="col">
          <a class="vmake__compare-product" href="${escapeHtml(item.url)}">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : ''}
            <strong>${escapeHtml(item.title)}</strong>
            <span>${escapeHtml(item.price)}</span>
          </a>
        </th>`).join('');
      const rowDefinitions = catalogMode === 'motorcycle' ? [
        ['Motorcycle coverage', 'coverage'],
        ['Diagnostic depth', 'depth'],
        ['Interface / adapters', 'connection'],
        ['Full-system scan', 'fullSystem'],
        ['Bi-directional / active tests', 'activeTests'],
        ['AutoVIN', 'autoVin'],
        ['Service functions', 'serviceFunctions'],
        ['Update method', 'updateMethod'],
        ['Software updates', 'updates'],
        ['Best for', 'reason']
      ] : [
        ['Vehicle coverage', 'coverage'],
        ['Diagnostic depth', 'depth'],
        ['Connection', 'connection'],
        ['Full-system scan', 'fullSystem'],
        ['Bi-directional / active tests', 'activeTests'],
        ['Service functions', 'serviceFunctions'],
        ['ECU coding', 'ecuCoding'],
        ['J2534 programming', 'j2534'],
        ['Topology map', 'topology'],
        ['Software updates', 'updates'],
        ['Best for', 'reason']
      ];
      const rows = rowDefinitions.map(([label, key]) => `
        <tr>
          <th scope="row">${escapeHtml(label)}</th>
          ${items.map((item) => `<td>${escapeHtml(item[key] || '—')}</td>`).join('')}
        </tr>`).join('');
      compareGrid.innerHTML = `<table class="vmake__compare-table"><thead><tr><th scope="col">Parameter</th>${header}</tr></thead><tbody>${rows}</tbody></table>`;
      compareModal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };

    const closeCompare = () => {
      if (!compareModal) return;
      compareModal.hidden = true;
      document.documentElement.style.overflow = '';
    };

    search?.addEventListener('focus', filterSuggestions);
    search?.addEventListener('input', filterSuggestions);
    search?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      const first = suggestionButtons().find((button) => !button.hidden);
      if (first) showMake(first.dataset.makeSelect, first.dataset.makeName);
    });

    compareOpen?.addEventListener('click', (event) => {
      event.preventDefault();
      openCompare();
    });
    root.querySelectorAll('[data-compare-clear]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        clearCompare();
      });
    });
    root.querySelectorAll('[data-compare-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeCompare();
      });
    });

    root.addEventListener('click', (event) => {
      const makeButton = event.target.closest('[data-make-select]');
      if (makeButton && root.contains(makeButton)) {
        event.preventDefault();
        showMake(makeButton.dataset.makeSelect, makeButton.dataset.makeName);
        return;
      }
      if (event.target.closest('[data-vmake-submit]')) {
        const first = suggestionButtons().find((button) => !button.hidden) || suggestionButtons()[0];
        if (first) showMake(first.dataset.makeSelect, first.dataset.makeName);
        return;
      }
      if (event.target.closest('[data-vmake-back]')) { showStart(); return; }
    });

    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-compare-toggle]')) return;
      setCompare(event.target.closest('[data-compare-card]'), event.target.checked);
    });

    document.addEventListener('click', (event) => {
      if (suggestions && !event.target.closest('[data-vmake-finder]')) suggestions.hidden = true;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && compareModal && !compareModal.hidden) closeCompare();
    });

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-make-panel]');
        const tile = event.target.closest('[data-make-select]');
        if (panel) showMake(panel.dataset.makePanel, panel.dataset.defaultMake, false);
        else if (tile) showMake(tile.dataset.makeSelect, tile.dataset.makeName, false);
      });
    }

    const urlBrand = new URL(window.location.href).searchParams.get('brand');
    if (urlBrand) {
      const match = suggestionButtons().find((button) => normalize(button.dataset.makeName) === normalize(urlBrand));
      if (match) showMake(match.dataset.makeSelect, match.dataset.makeName, false);
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-vmake-root]').forEach(initVehicleMake);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
